import React, { useState } from "react";
import Button from "../../../../shared/components/Buttons/Button";
import { buttonTypeConstants, toastType } from "../../../../constants";
import {
  ResetCartIcon,
  LoadingIndicatorCentered,
} from "../../../../assets/icons/iconsProvider";
import ConfirmationModal from "../../../Inventory/Items/ConfirmationModal/ConfirmationModal";
import { shopifyService } from "../../../../services";
import { customToast } from "../../../../shared/utility";

const UpdateInventoryButton = ({
  currentStore,
  isUpdatingInventoryPresetsToDefault,
  setIsUpdatingInventoryPresetsToDefault,
}) => {
  const [isConfirmationModal, setIsConfirmationModal] = useState(false);

  // open/close confirmation modal
  const toggleConfirmationModal = () => {
    setIsConfirmationModal((prev) => !prev);
  };

  // handles clicking the "Update Inventory" button
  const handleUpdateInventoryPresetsToDefault = () => {
    toggleConfirmationModal();
  };

  // confirm button handler
  const handleConfirmYesButtonClick = async () => {
    try {
      await shopifyService.updateInventoryPresetsToDefault(currentStore?.id);
      setIsUpdatingInventoryPresetsToDefault(true);
      toggleConfirmationModal();
    } catch (error) {
      customToast(error, toastType.ERROR);
      toggleConfirmationModal();
    }
  };

  // cancel button handler
  const handleConfirmNoButtonClick = () => {
    toggleConfirmationModal();
  };
  return (
    <>
      <Button
        IconImage={
          isUpdatingInventoryPresetsToDefault
            ? LoadingIndicatorCentered
            : ResetCartIcon
        }
        handleClick={handleUpdateInventoryPresetsToDefault}
        isDisabled={isUpdatingInventoryPresetsToDefault}
        label="Reset Existing Inventory"
        className="w-100 d-flex justify-content-center align-items-center text-center"
      />

      <ConfirmationModal
        isConfirmationModal={isConfirmationModal}
        handleNoButtonClick={handleConfirmNoButtonClick}
        handleYesButtonClick={handleConfirmYesButtonClick}
        toggleConfirmationModal={toggleConfirmationModal}
        message={`<h5>Confirm Shopify Configuration Reset for All Inventory Items</h5>
          <p>
              This action will replace all existing <strong>Shopify Configuration Settings</strong> for every item in your Inventory. 
              These settings will be replaced according to the current applicable <strong>Global</strong> and <strong>Custom Shopify Configuration</strong> settings for each item.
          </p>

          <p>This includes the following configurations:</p>
          <ul>
              <li>Link to Shopify</li>
              <li>Separate Collection &amp; Online Quantities</li>
              <li>All Shopify Field Mappings Settings</li>
          </ul>

          <p>While this update is running:</p>
          <ul>
              <li>
                  All <strong>inventory-related actions</strong> in LootLedger (Adding or Editing Inventory, etc.) will be temporarily disabled to prevent conflicts.
              </li>
              <li>Your connected Shopify Store’s Website will also be temporarily unavailable.</li>
              <li>
                  No changes or edits should be made directly on Shopify during the update process to avoid interruptions.
              </li>
          </ul>

          <p>
              It is highly recommended to only execute this action outside of your website’s high-traffic hours. 
              <strong>Are you sure you want to proceed?</strong>
          </p>`}
        yesButtonText="Confirm"
        noButtonText="Cancel"
        isHtmlMessage={true}
      />
    </>
  );
};

export default UpdateInventoryButton;
